module.exports = __webpack_public_path__ + "assets/img/binding-1-sm.e585ecd9.jpg";